module.exports = __webpack_public_path__ + "img/ken_to.73f6960b.jpg";